import FlexPane from './_flex-pane.js'
import SkeletonPart from './_skeleton-part.js'

export default {
  name: 'MarketGroupSelectorSkeleton',
  values: {
    marketSwitcherContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
      },
    },
    numberOfMarketSwitchers: 4,
    _mobile_numberOfMarketSwitchers: 3,
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '16px',
        style: {
          padding: '8px 0px 8px',
          _mobile_padding: '8px',
          flexDirection: 'column',
        },
      },
    },
    itemPlaceholder: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '88px',
          height: '40px',
          _mobile_flexShrink: 0,
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
